export const isBackSpace = (event) => {
  const key = event.keyCode || event.charCode;

  return key === 8 || key === 46;
};

export const phoneMask = (event) => {
  const mask = !isBackSpace(event)
    ? event.target.value
        .replace(/[^0-9]/g, "")
        .replace(/(.{1})(.*)/, "($1$2")
        .replace(/(.{3})(.*)/, "$1) $2")
        .replace(/(.{10})(.*)/, "$1-$2")
    : event.target.value;

  return mask;
};

export function parseCurrency(rawCurrency) {
  if (!rawCurrency) return rawCurrency;

  const currency = rawCurrency.replace(/\D/g, "");

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(Number(currency) / 100);
}
